<script lang="ts" setup>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Pagination } from 'swiper/modules'
import WellbeingSaleForEmployersCard from '../wellbeing-sale--forEmployers--card/wellbeing-sale--forEmployers--card.vue'
import type { IProps } from './wellbeing-sale--forEmployers--carousel.types'

import 'swiper/css'
import 'swiper/css/pagination'

defineProps<IProps>()

// TODO: change to UI if second usecase will be found

const modules = [Pagination]
const breakpoints = {
  0: {
    slidesPerView: 1,
    spaceBetween: 14,
  },
  360: {
    slidesPerView: 1.4,
    spaceBetween: 14,
  },
  480: {
    slidesPerView: 1.8,
    spaceBetween: 14,
  },
  577: {
    slidesPerView: 2.2,
    spaceBetween: 14,
  },
  768: {
    slidesPerView: 2.8,
    spaceBetween: 14,
  },
  992: {
    slidesPerView: 3.3,
    spaceBetween: 14,
  },
  1200: {
    slidesPerView: 3.3,
    spaceBetween: 32,
  },
  1600: {
    slidesPerView: 3.1,
    spaceBetween: 32,
  },
}

</script>

<template>
  <div
    :class="[
      'card-carousel',
    ]"
  >
    <div class="card-carousel__swiper">
      <swiper
        ref="sliderRef"
        :breakpoints="breakpoints"
        :modules="modules"
        pagination
      >
        <swiper-slide
          v-for="(slide, index) in slides"
          :key="index"
        >
          <WellbeingSaleForEmployersCard
            :image="slide.image"
            :title="slide.title"
            :description="slide.description"
            :label="slide.label"
          />
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.card-carousel {
  display: flex;
  flex-direction: column;
  padding: 0;

  &--gray {
    background-color: $gray-100;
  }

  &__header {
    margin-right: 2.4rem;
    font-weight: 500;
    font-size: 2.8rem;
    line-height: 3.6rem;
    text-align: center;
  }

  &__subheader {
    margin-top: 1.6rem;
    margin-right: 2.4rem;
    font-weight: 500;
    font-size: 2rem;
    line-height: 2.8rem;
    text-align: center;
  }

  &__swiper {
    max-width: 115.2rem;
    width: 100%;
    margin: 0 auto;
  }

  .button {
    align-self: center;
  }

  :deep() {
    .swiper {
      @include atM {
        margin-top: 6rem;
        margin-bottom: 6rem;
        overflow-x: visible;
      }

      .swiper-button-prev,
      .swiper-button-next {
        display: none;

        @include atS {
          position: absolute;
          top: 30%;
          z-index: 10;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 6rem;
          height: 6rem;
          background-position: center;
          visibility: hidden;
          cursor: pointer;
          opacity: 0;
          transition: all 0.3s ease-in-out;

          &.swiper-button-disabled {
            display: none;
          }
        }
      }

      .swiper-button-prev {
        @include atS {
          left: 0;
          background-image: url('/icons/icon_slider_arrow.svg');
          transform: rotate(180deg);
        }
      }
      .swiper-button-next {
        @include atS {
          right: 0;
          background-image: url('/icons/icon_slider_arrow.svg');
        }
      }

      &:hover {
        .swiper-button-prev,
        .swiper-button-next {
          visibility: visible;
          opacity: 1;
        }
      }

      .swiper-pagination-bullet-active {
        width: 6rem;
        background-color: $text-400;
        border-radius: 0;
      }
    }

    .swiper-horizontal {
      padding-bottom: 4rem!important;

      @include atM {
        padding-bottom: 6rem!important;
      }
    }
  }
}

@include atS {
  .card-carousel {
    :deep() {
      .swiper {

        .swiper-button-prev,
        .swiper-button-next {
          position: absolute;
          top: 30%;
          z-index: 10;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 6rem;
          height: 6rem;
          background-position: center;
          visibility: hidden;
          cursor: pointer;
          opacity: 0;
          transition: all 0.3s ease-in-out;

          &.swiper-button-disabled {
            display: none;
          }
        }

        .swiper-button-prev {
          left: 0;
          background-image: url('/icons/icon_slider_arrow.svg');
          transform: rotate(180deg);
        }
        .swiper-button-next {
          right: 0;
          background-image: url('/icons/icon_slider_arrow.svg');
        }
      }
    }
  }
}

@include atM {
  .card-carousel {
    padding: 12rem 0 8rem 2.4rem;
    
    :deep() {
      .swiper {
        margin-top: 6rem;
        margin-bottom: 6rem;
        overflow-x: visible;

        .swiper-horizontal {
          padding-bottom: 6rem!important;
        }
      }
    }

    &__header {
      font-size: 4.8rem;
      line-height: 5.6rem;
      text-align: left;
    }

    &__subheader {
      margin-top: 3.2rem;
    }

    &__swiper {
      max-width: 134rem;
    }
  }
}

@include atXL {
  .card-carousel {
    &__header {
      font-size: 5.6rem;
      line-height: 6.8rem;
    }

    &__subheader {
      margin-top: 4rem;
      font-size: 2.4rem;
      line-height: 3.2rem;
    }
  }
}

</style>
